import { gql, useFragment } from "@apollo/client";

// Constants
import { bgColorFields } from "@/constants/gql-fields";

// Styling
import style from "./header--mobile-nav.module.scss";

// Components
import BackgroundColor from "@/components/bg-color/bg-color";
import MenuWP from "../menu-wp/menu-wp";
import SocialIcons from "@/components/social-icons/social-icons";
import Container from "../container/container";
import Searchbar from "@/components/searchbar/searchbar";

export default function HeaderMobileNav({ data, navMobileState = {} }) {
  // -- Use Fragment
  const menuProps = useFragment({
    fragment: HeaderMobileNav.fragments.menus,
    fragmentName: "MobileMenus",
    from: {
      __typename: "RootQuery",
    },
  });
  const mobileProps = useFragment({
    fragment: HeaderMobileNav.fragments.entry,
    fragmentName: "MobileNavFragment",
    from: {
      __typename: data.__typename,
      id: data.id,
    },
  });
  if (!menuProps.complete || !mobileProps.complete) {
    return;
  }

  // Define Variables
  const content = mobileProps.data.headerContent.mobileNavContent;
  const settings = mobileProps.data.headerContent.mobileNavOptions;

  return (
    <div
      className={`${style.navMobile}`}
      type={settings.navType}
      state={navMobileState}
    >
      {settings.styleOptions && settings.styleOptions.includes("bg-color") && (
        <BackgroundColor
          colorSettings={
            settings.mobileNavBackgroundColor?.backgroundColorColorSettings
          }
        />
      )}

      <Container>
        <div
          className={style.mobileNavContent}
          hori-ori={settings.horizontalOrientation}
          vert-ori={settings.verticalOrientation}
        >
          {content.map((item, index) => {
            switch (item["contentItems"][0]) {
              case "main":
                return (
                  <MenuWP
                    menu={menuProps.data.primary}
                    navStyle="mobileMain"
                    key={index}
                  />
                );
              case "top":
                return (
                  <MenuWP
                    menu={menuProps.data.top}
                    navStyle="mobileTop"
                    key={index}
                  />
                );
              case "social":
                return <SocialIcons id={mobileProps.data.id} key={index} />;
              case "search":
                //return <div key={index}>Search Bar</div>;
                return (
                  <div className={style.mobileSearchWrapper} key={index}>
                    <h2>
                      Search
                      <br />
                      Ingredients
                    </h2>
                    <Searchbar mobile />
                  </div>
                );
              default:
                break;
            }
          })}
        </div>
      </Container>
    </div>
  );
}

HeaderMobileNav.fragments = {
  menus: gql`
    fragment MobileMenus on RootQuery {
      top: menu(id: "207", idType: DATABASE_ID) {
        id
        __typename
        ...WpMenuFragment @unmask(mode: "migrate")
      }
      primary: menu(id: "3", idType: DATABASE_ID) {
        id
        __typename
        ...WpMenuFragment @unmask(mode: "migrate")
      }
    }
    ${MenuWP.fragments.menu}
  `,

  entry: gql`
    fragment MobileNavFragment on GeneralSettingsACF {
      id
      __typename
      headerContent {
        mobileNavContent {
          contentItems
          includeSearchIcon
        }
        mobileNavOptions {
          navType
          styleOptions
          horizontalOrientation
          verticalOrientation
          mobileNavBackgroundColor {
            backgroundColorColorSettings {
              ${bgColorFields}
            }
          }
          mobileNavTextColor {
            textColorColorSettings {
              ${bgColorFields}
            }
          }
        }
      }
      ...SocialIconsFragment @unmask(mode: "migrate")
    }
    ${SocialIcons.fragments.entry}
  `,
};
